import React, { useEffect, Fragment } from "react";
import Styles from "./WhatDriveUs.module.scss";
import AOS from "aos";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { appLevelConstants } from "../../constants/AppLevelConstants";

export default function WhatDriveUs() {
  useEffect(() => {
    AOS.init();
  }, []);

  const items = appLevelConstants.program.whatsDrive;
  const lastIndex = items.length - 1;

  return (
    <section
      className={Styles.section}
      aria-labelledby="what-drive-heading"
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-easing="ease-in-out"
    >
      <div className={Styles.inner}>
        <header className={Styles.sectionHead}>
          <span className={Styles.eyebrow}>Why we exist</span>
          <h2 id="what-drive-heading" className={Styles.sectionTitle}>
            The gap we&apos;re closing
          </h2>
          <p className={Styles.sectionLead}>
            From systemic barriers to a platform built for real leadership impact.
          </p>
        </header>

        <div className={Styles.bento}>
          {items.map((item, index) => {
            const isResolution = index === lastIndex;
            return (
              <article
                data-aos="fade-up"
                data-aos-duration="900"
                data-aos-delay={index * 80}
                data-aos-easing="ease-out-cubic"
                className={`${Styles.card} ${isResolution ? Styles.cardResolution : Styles.cardProblem}`}
                key={item.id}
              >
                <div className={Styles.cardTop}>
                  <h3 className={Styles.cardTitle}>{item.title}</h3>
                </div>

                {!isResolution && (
                  <div className={Styles.visualShell}>
                    <div className={Styles.visualGlow} aria-hidden="true" />
                    <img className={Styles.visualImg} alt="" src={item.img} />
                  </div>
                )}

                <div className={Styles.copy}>
                  {item.description.map((des, desIndex) => (
                    <Fragment key={des.id}>
                      <p className={Styles.description}>
                        {item.id === 1 && desIndex === 0 ? (
                          des.value.split(" ").map((word, wordIndex, words) => {
                            const gap = wordIndex < words.length - 1 ? " " : null;
                            const isHi =
                              wordIndex === 3 ||
                              wordIndex === 4 ||
                              wordIndex === 5 ||
                              wordIndex === 6;
                            return (
                              <Fragment key={wordIndex}>
                                <span
                                  className={
                                    isHi
                                      ? `${Styles.description} ${Styles.highlight}`
                                      : Styles.description
                                  }
                                >
                                  {word}
                                </span>
                                {gap}
                              </Fragment>
                            );
                          })
                        ) : item.id === 2 && desIndex === 1 ? (
                          des.value.split(" ").map((word, wordIndex, words) => {
                            const gap = wordIndex < words.length - 1 ? " " : null;
                            const isHi = wordIndex === 14 || wordIndex === 15;
                            return (
                              <Fragment key={wordIndex}>
                                <span
                                  className={
                                    isHi
                                      ? `${Styles.description} ${Styles.highlight}`
                                      : Styles.description
                                  }
                                >
                                  {word}
                                </span>
                                {gap}
                              </Fragment>
                            );
                          })
                        ) : (
                          des.value
                        )}
                      </p>
                    </Fragment>
                  ))}
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
